<template>
    <span class="text-primary font-bold">{{ play.name }}</span>
    <span
        class="text-primary font-bold absolute top-[15px]"
        v-if="isPlayShared"
        :style="`${displayMode == 'grid' ? 'top: 15px' : 'top: 0;left: 20px;'}`"
        >Shared</span
    >
    <context-menu
        class="right-2 top-2 absolute parent"
        v-if="
            !play.access_type ||
            (play.access_type && play.access_type !== 'view')
        "
    >
        <li>
            <a
                class="
                    py-1
                    pl-4
                    pr-8
                    flex flex-row
                    items-center
                    text-left
                    gap-2
                    cursor-pointer
                    hover:bg-gray-300
                    rounded-lg
                "
                @click="sharePlay()"
                v-if="!isTeamPlaybook && canShare"
            >
                <ion-icon name="share-outline"></ion-icon>
                <div class="flex-grow-1 flex-shrink-0 font-slab mt-1">
                    Share
                </div>
            </a>
        </li>
        <li>
            <a
                class="
                    py-1
                    pl-4
                    pr-8
                    flex flex-row
                    items-center
                    text-left
                    gap-2
                    cursor-pointer
                    hover:bg-gray-300
                    rounded-lg
                "
                :href="href"
            >
                <ion-icon name="create-outline"></ion-icon>
                <div class="flex-grow-1 flex-shrink-0 font-slab mt-1">Edit</div>
            </a>
        </li>

        <li>
            <rename-play-modal
                :play="play"
                class="
                    py-1
                    pl-4
                    pr-8
                    my-1
                    hover:bg-gray-300
                    rounded-lg
                    cursor-pointer
                    flex
                    gap-2
                    items-center
                "
            >
                <img
                    src="/default-images/icons/rename-outline.svg"
                    width="16"
                />
                Rename</rename-play-modal
            >
        </li>
        <li
            ref="movePlaybookRef"
            @click.prevent.stop="showMovePlaybook = true"
            v-if="playbook.playbook_id != -2"
        >
            <a
                class="
                    py-1
                    pl-4
                    pr-8
                    flex flex-row
                    items-center
                    text-left
                    gap-2
                    cursor-pointer
                    hover:bg-gray-300
                    rounded-lg
                "
            >
                <ion-icon
                    class="flex-grow-0 flex-shrink-0"
                    name="enter-outline"
                ></ion-icon>
                <div class="flex-grow flex-shrink font-slab mt-1">
                    <span v-if="play.is_template">Move to Template Group</span>
                    <span v-else>Move to Playbook</span>
                </div>
            </a>
        </li>
        <li ref="copyPlaybookRef" @click.prevent.stop="showCopyPlaybook = true">
            <a
                class="
                    py-1
                    pl-4
                    pr-8
                    flex flex-row
                    items-center
                    text-left
                    gap-2
                    cursor-pointer
                    hover:bg-gray-300
                    rounded-lg
                "
            >
                <ion-icon
                    class="flex-grow-0 flex-shrink-0"
                    name="copy-outline"
                ></ion-icon>
                <div class="flex-grow flex-shrink font-slab mt-1">
                    <span v-if="play.is_template">Copy to Template Group</span>
                    <span v-else>Copy to Playbook</span>
                </div>
            </a>
        </li>
        <li
            ref="copyTeamPlaybookRef"
            @click.prevent.stop="showCopyTeamPlaybook = true"
            v-show="!isTeamPlaybook && !play.is_template"
        >
            <a
                class="
                    py-1
                    pl-4
                    pr-8
                    flex flex-row
                    items-center
                    text-left
                    gap-2
                    cursor-pointer
                    hover:bg-gray-300
                    rounded-lg
                "
            >
                <ion-icon
                    class="flex-grow-0 flex-shrink-0"
                    name="log-out-outline"
                ></ion-icon>
                <div class="flex-grow flex-shrink font-slab mt-1">
                    Copy to Team Playbook
                </div>
            </a>
        </li>
        <li
            ref="mirrorPlaybookRef"
            @click.prevent.stop="showMirrorPlaybook = true"
            v-if="!play.is_template && !play.mirror_play_id"
        >
            <a
                class="
                    py-1
                    pl-4
                    pr-8
                    flex flex-row
                    items-center
                    text-left
                    gap-2
                    cursor-pointer
                    hover:bg-gray-300
                    rounded-lg
                "
            >
                <ion-icon
                    class="flex-grow-0 flex-shrink-0"
                    name="git-compare-outline"
                ></ion-icon>
                <div class="flex-grow flex-shrink font-slab mt-1">
                    <span>Mirror to Playbook</span>
                </div>
            </a>
        </li>

        <li @click="$refs.deleteMirror.submit()" v-if="mirrors?.length > 0">
            <form
                :action="`/plays/${play.play_id}/stop-mirroring`"
                method="post"
                ref="deleteMirror"
            >
                <input type="hidden" name="_token" :value="$root.csrfToken" />
                <input type="hidden" name="play_id" :value="play.play_id" />
                <div
                    class="
                        py-1
                        pl-4
                        pr-8
                        flex flex-row
                        items-center
                        text-left
                        gap-2
                        cursor-pointer
                        hover:bg-gray-300
                        rounded-lg
                    "
                >
                    <ion-icon name="close-circle-outline"></ion-icon>
                    <button
                        type="submit"
                        class="flex-grow-1 flex-shrink-0 font-slab mt-1"
                    >
                        Stop Mirroring
                    </button>
                </div>
            </form>
        </li>

        <li v-if="!play.is_template">
            <a
                class="
                    py-1
                    pl-4
                    pr-8
                    flex flex-row
                    items-center
                    text-left
                    gap-2
                    cursor-pointer
                    hover:bg-gray-300
                    rounded-lg
                "
                @click="viewNotes(play)"
            >
                <ion-icon
                    class="flex-grow-0 flex-shrink-0"
                    name="document-text-outline"
                ></ion-icon>
                <div class="flex-grow flex-shrink font-slab mt-1">
                    <span>View Notes</span>
                </div>
            </a>
        </li>
        <li v-if="!play.is_template && !play.name">
            <VideoSelectorModal
                :play="play"
                :update-video-tags-api="updateVideoTagsApi"
                :video-api="videoApi"
                class="
                    py-1
                    pl-4
                    pr-8
                    flex flex-row
                    items-center
                    text-left
                    gap-2
                    cursor-pointer
                    hover:bg-gray-300
                    rounded-lg
                "
            >
                <ion-icon
                    class="flex-grow-0 flex-shrink-0"
                    name="pricetags-outline"
                ></ion-icon>
                <div class="flex-grow flex-shrink font-slab mt-1">
                    Tag Video
                </div>
            </VideoSelectorModal>
        </li>

        <li @click="$refs.deleteForm.submit()">
            <form :action="deleteApi" method="post" ref="deleteForm">
                <input type="hidden" name="_token" :value="$root.csrfToken" />
                <input type="hidden" name="play_id" :value="play.play_id" />
                <div
                    class="
                        py-1
                        pl-4
                        pr-8
                        flex flex-row
                        items-center
                        text-left
                        gap-2
                        cursor-pointer
                        hover:bg-gray-300
                        rounded-lg
                        text-red-500
                    "
                >
                    <ion-icon name="trash-outline"></ion-icon>
                    <button
                        type="submit"
                        class="flex-grow-1 flex-shrink-0 font-slab mt-1"
                    >
                        Delete
                    </button>
                </div>
            </form>
        </li>
    </context-menu>
    <ViewPlayNotes
        :title="notes.title"
        :notes="notes.text"
        :is-open="notes.isOpen"
        @close="notes.isOpen = false"
    ></ViewPlayNotes>
    <div>
        <div
            class="relative group flex flex-col"
            :style="`
width: ${displayMode === 'grid' ? '100%' : 'min(100%, 300px)'};
gap: ${displayMode === 'grid' ? '0px' : '10px'};
`"
        >
            <label
                v-if="isSelectMode"
                class="
                    absolute
                    top-2
                    left-2
                    z-20
                    bg-white
                    rounded
                    p-1
                    shadow
                    cursor-pointer
                    flex
                    items-center
                "
                @click.stop
            >
                <input
                    type="checkbox"
                    class="w-5 h-5 cursor-pointer accent-primary"
                    :checked="isSelected"
                    @change="toggleSelect"
                />
            </label>
            <img
                :src="play.thumbnail_url ?? thumbnail"
                alt="Play Thumbnail"
                class="
                    bg-white
                    flex-grow flex-shrink
                    w-full
                    rounded-md
                    my-4
                    object-contain
                "
                :style="{
                    backgroundImage: `linear-gradient(to bottom, #fffa, #fffa), url('${
                        play.background ?? thumbnail
                    }')`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    aspectRatio: 2.07339829981,
                    maxWidth: '350px',
                    width: `${displayMode == 'grid' ? '100%' : '100%'}`,
                    height: `${displayMode == 'grid' ? '100%' : '100%'}`,
                    flexGrow: `${displayMode == 'grid' ? '1' : '0'}`,
                }"
                onerror="this.onerror=null;this.src='/default-images/dummy-play.png';this.style.backgroundImage = 'none';"
            />

            <div class="flex items-center justify-center">
                <div class="flex-grow flex-shrink">
                    <h3 class="font-semibold">
                        {{ play.play_name }}
                        <span v-if="mirrors?.length > 0"> (Mirroring) </span>
                    </h3>
                    <div class="text-xs md:text-sm text-gray-400">
                        Created at
                        {{ new Date(play.created_at).toLocaleString() }}
                    </div>
                </div>
                <a :href="href" class="text-primary text-2xl">
                    <ion-icon name="arrow-forward-outline"></ion-icon>
                </a>
            </div>
        </div>
        <div
            class="flex gap-2 items-center mt-2"
            v-if="
                displayMode == 'list' &&
                playbook.playbook_id !== -2 &&
                canManage
            "
        >
            <div
                class="
                    my-auto
                    flex flex-col
                    border-[1px] border-black
                    rounded-lg
                    overflow-hidden
                    text-xs
                    w-full
                "
            >
                <FormationSelector
                    :formations="formations"
                    :value="play.formation_id"
                    :team-id="play.team_id"
                    @update:modelValue="updateFormation"
                />
                <PackageSelector
                    :packages="packages"
                    :value="play.package_id"
                    :team-id="play.team_id"
                    @update:modelValue="updatePackage"
                />
            </div>
            <FormationPackageSetting
                :team-id="play.team_id"
            ></FormationPackageSetting>
        </div>
    </div>
    <div
        class="
            flex flex-col
            gap-2
            w-full
            pt-[20px]
            flex-1
            items-center
            max-w-[275px]
        "
        v-if="displayMode == 'list'"
    >
        <div class="p-4 bg-white flex flex-col" v-if="playActiveVideo">
            <CustomVideoPlayer
                :is-screen-auto="true"
                :thumbnail="playActiveVideo.thumbnail"
                :url="playActiveVideo.url"
                :title="playActiveVideo.title"
                :start-sec="playActiveVideo.start_sec ?? null"
                :end-sec="playActiveVideo.end_sec ?? null"
                v-if="playActiveVideo"
            ></CustomVideoPlayer>
            <button
                class="
                    bg-gradient-to-br
                    from-primary
                    to-primaryLight
                    text-white
                    rounded-lg
                    p-1
                    px-4
                    mt-4
                "
                @click="openVideoPreview(playActiveVideo)"
            >
                View
            </button>
        </div>
        <div class="grid grid-cols-2 gap-2 flex-wrap justify-center">
            <div
                v-for="video in otherVideos"
                :key="video.id"
                class="max-h-[85px] max-w-[135px]"
            >
                <CustomVideoPlayer
                    :is-screen-auto="true"
                    :hide-play-button="true"
                    :is-custom-play-click="true"
                    :thumbnail="video.thumbnail"
                    :url="video.url"
                    :title="video.title"
                    :start-sec="video.start_sec ?? null"
                    :end-sec="video.end_sec ?? null"
                    @customplay="activeVideo = video"
                ></CustomVideoPlayer>
            </div>
        </div>
    </div>

    <div
        v-if="displayMode == 'list'"
        class="play-note text-sm mr-6 !h-fit w-full"
    >
        <div
            v-if="play.play_note"
            v-html="play.play_note"
            class="ql-editor border-[1px] border-gray-500 rounded p-2"
        ></div>
    </div>
    <ModalCustom
        :is-open="share.isOpen"
        @close="share.isOpen = false"
        title="Share Play"
    >
        <div class="flex items-center justify-center" v-if="share.isGenerating">
            <simple-loading-circle />
        </div>
        <div class="flex items-center bg-gray-200 rounded p-2 gap-2" v-else>
            <input
                type="text"
                class="w-full w-max-[240px] bg-transparent outline-none"
                :value="share.link"
                readonly
                @click="$event.target.select()"
            />
            <button
                class="bg-gray-300 rounded p-2"
                @click="copyShareLink"
                title="Copy to clipboard"
            >
                <ion-icon name="copy-outline"></ion-icon>
            </button>
        </div>
        <div class="mt-6">
            <input
                type="checkbox"
                :readonly="share.isLoading"
                v-model="share.isPublic"
                id="share_is_public"
                @change="updateShareVisibility"
            />
            <label for="share_is_public">
                <span class="ml-2">Public</span>
            </label>
            <div class="text-sm text-gray-500">
                Public plays can be viewed by anyone with the link.
            </div>
        </div>
        <div class="mt-6" v-if="!share.isPublic">
            <h4 class="uppercase text-sm font-semibold">Allowed User</h4>
            <div
                class="my-4 flex gap-2 flex-wrap max-w-lg"
                v-if="share.members.length > 0"
            >
                <div
                    v-for="(member, index) in share.members"
                    :key="index"
                    class="
                        text-sm
                        p-2
                        rounded
                        inline-flex
                        bg-gray-100
                        gap-2
                        items-center
                    "
                >
                    <img
                        :src="member.user?.avatar"
                        :alt="member.user?.name"
                        v-if="member.user?.avatar"
                        class="w-8 h-8 rounded-full aspect-square"
                    />
                    {{ member.user?.name ?? member.email }}
                    <button
                        type="button"
                        class="
                            bg-transparent
                            text-gray-500
                            flex
                            items-center
                            hover:text-gray-700 hover:bg-gray-300
                            p-1
                            rounded-lg
                        "
                        @click="removeShareMember(index)"
                    >
                        <ion-icon name="close-outline"></ion-icon>
                    </button>
                </div>
            </div>
            <div class="flex items-center gap-2 my-4">
                <MemberMultiselectInput
                    :current-users="share.members"
                    :selected-users="share.selectedUsers"
                    @select="addShareMember"
                    @remove="removeShareMember"
                ></MemberMultiselectInput>
            </div>
            <h4 class="uppercase text-sm font-semibold">External User</h4>
            <div class="flex items-center gap-2 my-4">
                <NonMemberMultiselectInput
                    :current-users="share.members"
                    :selected-users="share.selectedEmails"
                    @select="addShareExternal"
                    @remove="removeShareExternal"
                ></NonMemberMultiselectInput>
            </div>
            <div class="flex">
                <button
                    @click="saveShareMember()"
                    class="bg-primary text-white rounded-lg p-1 px-4 mt-4"
                >
                    Share
                </button>
            </div>
        </div>
        <div
            v-if="!share.isPublic && share.members.length === 0"
            class="bg-blue-100 text-gray-700 p-2 my-4 text-xs rounded"
        >
            This play can be only viewed by you.
        </div>
    </ModalCustom>
    <Teleport to="body" v-show="showMovePlaybook">
        <div
            class="fixed w-full h-full z-30 top-0 left-0"
            v-if="showMovePlaybook"
            @click.self="showMovePlaybook = false"
        ></div>
        <div
            ref="movePlaybookPopup"
            class="absolute bg-gray-200 shadow-xl rounded-lg z-40 text-black"
            v-show="showMovePlaybook"
        >
            <div class="p-2">
                <div class="flex flex-col gap-2">
                    <form
                        v-for="playbook in playbooksWithoutCurrentPlaybook"
                        method="post"
                        :action="moveApi"
                        :key="playbook.playbook_id"
                    >
                        <input
                            type="hidden"
                            name="play_id"
                            :value="play.play_id"
                        />
                        <input
                            type="hidden"
                            name="playbook_id"
                            :value="playbook.playbook_id"
                        />
                        <input
                            type="hidden"
                            name="_token"
                            :value="this.$root.csrfToken"
                        />
                        <button
                            type="submit"
                            class="
                                bg-gray-100
                                py-2
                                px-3
                                rounded-md
                                hover:bg-primary hover:text-white
                                cursor-pointer
                            "
                        >
                            {{ playbook.playbook_title }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </Teleport>
    <Teleport to="body" v-show="showCopyPlaybook">
        <div
            class="fixed w-full h-full z-30 top-0 left-0"
            v-if="showCopyPlaybook"
            @click.self="showCopyPlaybook = false"
        ></div>
        <div
            ref="copyPlaybookPopup"
            class="absolute bg-gray-200 shadow-xl rounded-lg z-40 text-black"
            v-show="showCopyPlaybook"
        >
            <div class="p-2">
                <div class="flex flex-col gap-2">
                    <form
                        v-for="cplaybook in playbooksWithoutCurrentPlaybook"
                        method="post"
                        :action="copyApi"
                        :key="cplaybook.playbook_id"
                    >
                        <input
                            type="hidden"
                            name="play_id"
                            :value="play.play_id"
                        />
                        <input
                            type="hidden"
                            name="team_id"
                            :value="play.team_id"
                        />
                        <input
                            type="hidden"
                            name="playbook_id"
                            :value="cplaybook.playbook_id"
                        />
                        <input
                            type="hidden"
                            name="_token"
                            :value="this.$root.csrfToken"
                        />
                        <button
                            type="submit"
                            class="
                                bg-gray-100
                                py-2
                                px-3
                                rounded-md
                                hover:bg-primary hover:text-white
                                cursor-pointer
                            "
                        >
                            {{ cplaybook.playbook_title }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </Teleport>
    <Teleport to="body" v-show="showCopyTeamPlaybook">
        <div
            class="fixed w-full h-full z-30 top-0 left-0"
            v-if="showCopyTeamPlaybook"
            @click.self="showCopyTeamPlaybook = false"
        ></div>
        <div
            ref="copyTeamPlaybookPopup"
            class="absolute bg-gray-200 shadow-xl rounded-lg z-40 text-black"
            v-show="showCopyTeamPlaybook"
        >
            <div class="p-2">
                <div class="flex flex-col gap-2">
                    <form
                        v-for="team in teams"
                        method="post"
                        :action="copyApi"
                        :key="team.id"
                    >
                        <input type="hidden" name="playbook_id" value="-1" />
                        <input type="hidden" name="team_id" :value="team.id" />
                        <input
                            type="hidden"
                            name="play_id"
                            :value="play.play_id"
                        />
                        <input
                            type="hidden"
                            name="_token"
                            :value="this.$root.csrfToken"
                        />
                        <button
                            type="submit"
                            class="
                                bg-gray-100
                                py-2
                                px-3
                                rounded-md
                                hover:bg-primary hover:text-white
                                cursor-pointer
                            "
                        >
                            {{ team.name }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </Teleport>
    <Teleport to="body" v-show="showMirrorPlaybook">
        <div
            class="fixed w-full h-full z-30 top-0 left-0"
            v-if="showMirrorPlaybook"
            @click.self="showMirrorPlaybook = false"
        ></div>
        <div
            ref="mirrorPlaybookPopup"
            class="absolute bg-gray-200 shadow-xl rounded-lg z-40 text-black"
            v-show="showMirrorPlaybook"
        >
            <div class="p-2">
                <div class="flex flex-col gap-2">
                    <form
                        v-for="cplaybook in mirroringPlaybooks"
                        method="post"
                        :action="mirrorApi"
                        :key="cplaybook.playbook_id"
                    >
                        <input
                            type="hidden"
                            name="play_id"
                            :value="play.play_id"
                        />
                        <input
                            type="hidden"
                            name="team_id"
                            :value="play.team_id"
                        />
                        <input
                            type="hidden"
                            name="playbook_id"
                            :value="cplaybook.playbook_id"
                        />
                        <input
                            type="hidden"
                            name="_token"
                            :value="this.$root.csrfToken"
                        />
                        <button
                            type="submit"
                            class="
                                bg-gray-100
                                py-2
                                px-3
                                rounded-md
                                hover:bg-primary hover:text-white
                                cursor-pointer
                            "
                        >
                            {{ cplaybook.playbook_title }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import ModalCustom from "./ModalCustom";
import { createPopper } from "@popperjs/core";
import SimpleLoadingCircle from "./SimpleLoadingCircle.vue";
import NewInput from "./forms/NewInput.vue";
import AppButton from "./AppButton.vue";
import VideoSelectorModal from "./VideoSelectorModal.vue";
import UserAutocompleteInput from "./forms/UserAutocompleteInput.vue";
import MemberMultiselectInput from "./forms/MemberMultiselectInput.vue";
import NonMemberMultiselectInput from "./forms/NonMemberMultiselectInput.vue";
import emitter from "tiny-emitter/instance";
import bulkSelection from "../stores/bulkSelection";

export default {
    name: "PlayCard",
    components: {
        UserAutocompleteInput,
        AppButton,
        NewInput,
        SimpleLoadingCircle,
        ModalCustom,
        VideoSelectorModal,
        MemberMultiselectInput,
        NonMemberMultiselectInput,
    },
    props: [
        "canShare",
        "canManage",
        "deleteApi",
        "play",
        "teamId",
        "href",
        "thumbnail",
        "playbooks",
        "playbook",
        "moveApi",
        "copyApi",
        "mirrorApi",
        "isTeamPlaybook",
        "teams",
        "videoApi",
        "updateVideoTagsApi",
        "isShared",
        "displayMode",
        "formations",
        "packages",
        "mirrors",
    ],
    computed: {
        selectionKey() {
            return `playbook-${this.playbook?.playbook_id}`;
        },
        isSelectMode() {
            return bulkSelection.isMode(this.selectionKey);
        },
        isSelected() {
            return bulkSelection.isSelected(
                this.selectionKey,
                this.play.play_id
            );
        },
        playbooksWithoutCurrentPlaybook() {
            if (!this.playbooks) {
                return [];
            }
            const playbookId = this.playbook.playbook_id ?? -1;
            return this.playbooks.filter(
                (playbook) =>
                    playbook.playbook_id != playbookId &&
                    playbook.playbook_id >= -1
            );
        },
        mirroringPlaybooks() {
            if (!this.playbooks) {
                return [];
            }
            const playbookId = this.playbook.playbook_id ?? -1;
            return this.playbooks.filter(
                (playbook) =>
                    playbook.playbook_id != playbookId &&
                    playbook.playbook_id >= -1 &&
                    !this.mirrors?.includes(playbook.playbook_id)
            );
        },
        isPlayShared() {
            if (this.share.isLoaded) {
                return this.share.members.length > 0;
            }

            return this.isShared;
        },
        playLabel() {
            if (this.label) {
                return this.label;
            }
            return this.play.label;
        },

        playActiveVideo() {
            if (this.activeVideo) {
                return this.activeVideo;
            }

            if (this.play?.videos?.length > 0) {
                return this.play.videos[0];
            }
        },

        otherVideos() {
            return this.play.videos?.filter(
                (video) => video.id !== this.playActiveVideo?.id
            );
        },
    },
    watch: {
        showMovePlaybook() {
            if (this.showMovePlaybook) {
                this.$nextTick(() => {
                    createPopper(
                        this.$refs.movePlaybookRef,
                        this.$refs.movePlaybookPopup,
                        {
                            placement: "right",
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [0, 8],
                                    },
                                },
                            ],
                        }
                    ).forceUpdate();
                });
            }
        },
        showCopyPlaybook() {
            if (this.showCopyPlaybook) {
                this.$nextTick(() => {
                    createPopper(
                        this.$refs.copyPlaybookRef,
                        this.$refs.copyPlaybookPopup,
                        {
                            placement: "right",
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [0, 8],
                                    },
                                },
                            ],
                        }
                    ).forceUpdate();
                });
            }
        },
        showCopyTeamPlaybook() {
            if (this.showCopyTeamPlaybook) {
                this.$nextTick(() => {
                    createPopper(
                        this.$refs.copyTeamPlaybookRef,
                        this.$refs.copyTeamPlaybookPopup,
                        {
                            placement: "right",
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [0, 8],
                                    },
                                },
                            ],
                        }
                    ).forceUpdate();
                });
            }
        },

        showMirrorPlaybook() {
            if (this.showMirrorPlaybook) {
                this.$nextTick(() => {
                    createPopper(
                        this.$refs.mirrorPlaybookRef,
                        this.$refs.mirrorPlaybookPopup,
                        {
                            placement: "right",
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [0, 8],
                                    },
                                },
                            ],
                        }
                    ).forceUpdate();
                });
            }
        },
    },
    data() {
        return {
            isOpen: false,
            showMovePlaybook: false,
            showCopyPlaybook: false,
            showCopyTeamPlaybook: false,
            showMirrorPlaybook: false,
            isShareOpen: false,
            isGeneratingShareLink: false,
            shareLink: null,
            label: null,
            share: {
                link: null,
                isGenerating: false,
                isOpen: false,
                isPublic: false,
                members: [],
                memberInput: "",
                isLoading: false,
                token: null,
                isLoaded: false,
                selectedUsers: [],
                selectedEmails: [],
            },
            notes: {
                isOpen: false,
                text: "",
            },
            activeVideo: null,
        };
    },
    methods: {
        toggleSelect() {
            bulkSelection.toggle(this.selectionKey, this.play.play_id);
        },
        addShareMember(user) {
            this.share.selectedUsers.push(user);
        },
        addShareExternal(user) {
            this.share.selectedEmails.push(user);
        },
        removeShareExternal(user) {
            this.share.selectedEmails = this.share.selectedEmails.filter(
                (u) => u.email !== user.email
            );
        },
        async saveShareMember() {
            try {
                this.share.isLoading = true;
                const res = await axios.post(
                    `/shared-link/member/${this.share.token}/batch-add`,
                    {
                        users: this.share.selectedUsers,
                        emails: this.share.selectedEmails,
                    }
                );
                this.share.members = [...this.share.members, ...res.data];
            } catch (e) {
                console.log(e);
            }
            this.share.selectedUsers = [];
            this.share.selectedEmails = [];
            this.share.isLoading = false;
        },
        async removeShareMember(index) {
            const removed = this.share.members.splice(index, 1);
            await axios.post(`/shared-link/member/${this.share.token}/remove`, {
                id: removed[0].id,
            });
        },
        async updateShareVisibility() {
            try {
                this.share.isLoading = true;
                await axios.post(`/shared-link/update/${this.share.token}`, {
                    visibility: this.share.isPublic ? "public" : "private",
                });
            } catch (e) {
                console.log(e);
            }
            this.share.isLoading = false;
        },
        async updateFormation(formation_id) {
            this.play.formation_id = formation_id;
            axios.post(`/plays/${this.play.play_id}/update-formation`, {
                formation_id,
            });
        },
        async updatePackage(package_id) {
            this.play.package_id = package_id;
            axios.post(`/plays/${this.play.play_id}/update-package`, {
                package_id,
            });
        },
        handleSubmit() {},
        sharePlay() {
            this.share.isOpen = true;
            this.share.isGenerating = true;
            axios
                .post("/shared-link/create", {
                    resource_type: "whiteboard_plays",
                    resource_id: this.play.play_id,
                })
                .then((response) => {
                    this.share.isGenerating = false;
                    this.share.link = response.data.link;
                    this.share.members = response.data.data.members.map(
                        (member) => member
                    );
                    this.share.token = response.data.data.token;
                    this.share.isPublic =
                        response.data.data.visibility === "public";
                    this.share.isLoaded = true;
                })
                .catch((error) => {
                    this.share.isGenerating = false;
                    console.log(error);
                });
        },
        copyShareLink() {
            navigator.clipboard.writeText(this.share.link);
        },
        viewNotes(play) {
            this.notes.isOpen = true;
            this.notes.title = `"${play.play_name}"  Notes`;
            this.notes.text = play.play_note;
        },
        openVideoPreview(video) {
            emitter.emit("open-play-stacked-video", {
                video,
                image: this.play.thumbnail_url,
            });
        },
    },
};
</script>

<style scoped>
.play-note {
    flex: 1;
}

@media (max-width: 1180px) {
    .play-note {
        width: 100%;
        flex-grow: 0;
        flex-shrink: 1;
        flex-basis: 100%;
    }
}
</style>
